import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';

// TODO - If we ever actually implement other languages, we'll want to load them dynamically.
const resources = {
    // Hardcoding english for now.
    en,
}

i18next
    //   // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    //   // learn more: https://github.com/i18next/i18next-http-backend
    //   .use(Backend)
    //   // detect user language
    //   // learn more: https://github.com/i18next/i18next-browser-languageDetector
    //   .use(LanguageDetector)
    // Pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // Init i18next. For all options read: https://www.i18next.com/overview/configuration-options
    .init({
        // debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        lng: 'en',
        react: {
            // We're bundling the translations, so no need for suspense.
            useSuspense: false,
        },
        resources,
    });

// This module initializes i18next without exporting anything, which makes webpack think it's unused,
// so export a dummy function that gets called to prevent it from getting tree shaken by webpack.
export function preventI18nTreeShake(){
    (<any>window).__inittedI18Next = true;
}

// The "t" function doesn't have "this" bound by default and needs to be bound in order to use it as a pure function.
i18next.t = i18next.t.bind(i18next);
export const t = i18next.t;